/**
 * Floating Video widget
 *
 * Pairs with snippets/floating-video.liquid + assets/floating-video.css.
 *
 * - The floating preview autoplays muted on loop (handled by the `video_tag`
 *   attributes in the snippet).
 * - Clicking the preview opens the theme's <modal-content>. The modal player has
 *   no autoplay attribute; this element plays it (with sound) when the modal opens
 *   and pauses/resets it when the modal closes, using the theme's
 *   `openable-element:open` / `openable-element:close` events.
 * - A dismiss (x) button hides the widget for the rest of the browsing session.
 */
(function () {
  var DISMISS_KEY = 'manam:floating-video-dismissed';

  var FloatingVideo = class extends HTMLElement {
    connectedCallback() {
      // Respect a previous dismissal for this session.
      try {
        if (window.sessionStorage.getItem(DISMISS_KEY) === '1') {
          this.hidden = true;
          return;
        }
      } catch (e) {
        // sessionStorage may be unavailable (private mode); ignore and continue.
      }

      this.preview = this.querySelector('.floating-video__preview');
      this.widget = this.querySelector('.floating-video__widget');
      this.modal = this.querySelector('#floating-video-modal');
      this.player = this.querySelector('#floating-video-player');

      this.onOpen = this._onOpen.bind(this);
      this.onClose = this._onClose.bind(this);
      this.onDismiss = this._onDismiss.bind(this);

      if (this.modal) {
        this.modal.addEventListener('openable-element:open', this.onOpen);
        this.modal.addEventListener('openable-element:close', this.onClose);
      }

      var dismissButton = this.querySelector('[data-action="dismiss"]');
      if (dismissButton) {
        dismissButton.addEventListener('click', this.onDismiss);
      }
    }

    disconnectedCallback() {
      if (this.modal) {
        this.modal.removeEventListener('openable-element:open', this.onOpen);
        this.modal.removeEventListener('openable-element:close', this.onClose);
      }
    }

    _onOpen() {
      if (this.widget) {
        this.widget.classList.add('is-hidden');
      }

      if (this.preview) {
        this.preview.pause();
      }

      if (this.player) {
        this.player.muted = false;
        try {
          this.player.currentTime = 0;
        } catch (e) {
          // Ignore if metadata isn't loaded yet.
        }
        var playback = this.player.play();
        if (playback && typeof playback.catch === 'function') {
          playback.catch(function () {
            /* Autoplay with sound blocked -- the visible controls let the user start it. */
          });
        }
      }
    }

    _onClose() {
      if (this.widget) {
        this.widget.classList.remove('is-hidden');
      }

      if (this.player) {
        this.player.pause();
        try {
          this.player.currentTime = 0;
        } catch (e) {
          // Ignore.
        }
      }

      if (this.preview) {
        var playback = this.preview.play();
        if (playback && typeof playback.catch === 'function') {
          playback.catch(function () {});
        }
      }
    }

    _onDismiss() {
      // Make sure the modal is closed if it happens to be open.
      if (this.modal) {
        this.modal.open = false;
      }
      this.hidden = true;
      try {
        window.sessionStorage.setItem(DISMISS_KEY, '1');
      } catch (e) {
        // Ignore if sessionStorage is unavailable.
      }
    }
  };

  window.customElements.define('floating-video', FloatingVideo);
})();
